const state = {
  orgCode: 0,
  userData: {},
  userStatus:false
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  SET_OrgCode: (state, orgCode) => {
    state.orgCode = orgCode
  },
  setUserData (state, evnt) {
    state.userData  = evnt
  },
  setUserStatus (state, evnt) {
    state.userStatus  = evnt
  }
  
}


const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  setOrgCode({ commit }, data) {
    commit('SET_OrgCode', data)
  },
  
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/SRM/store/modules/user.js